import { useState, useRef, useEffect } from "react";
import { gsap } from "gsap";

export default function FloatingLabelInput({
  label,
  type = "text",
  name,
  id,
  value,
  onChange,
  required = false,
  className = "",
  placeholder,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const labelRef = useRef(null);
  const inputRef = useRef(null);

  const hasValue = value && value.length > 0;

  // Initialiser le label en position flottante si le champ a déjà une valeur
  useEffect(() => {
    if (hasValue && labelRef.current) {
      gsap.set(labelRef.current, {
        y: -20,
        scale: 0.85,
        color: "rgba(137, 33, 216, 1)",
      });
    }
  }, [hasValue]);

  const handleFocus = () => {
    setIsFocused(true);
    gsap.to(labelRef.current, {
      y: -20,
      scale: 0.85,
      color: "rgba(137, 33, 216, 1)",
      duration: 0.3,
      ease: "power2.out",
    });
  };

  const handleBlur = () => {
    setIsFocused(false);
    if (!hasValue) {
      gsap.to(labelRef.current, {
        y: 0,
        scale: 1,
        color: "rgba(255, 255, 255, 0.5)",
        duration: 0.3,
        ease: "power2.out",
      });
    } else {
      // Garder la couleur violette si le champ a une valeur
      gsap.set(labelRef.current, {
        color: "rgba(137, 33, 216, 1)",
      });
    }
  };

  return (
    <div className={`floating-label-input-contact ${className}`}>
      {type === "textarea" ? (
        <textarea
          ref={inputRef}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          required={required}
          rows={5}
          className="form-textarea"
          placeholder=""
        />
      ) : (
        <input
          ref={inputRef}
          type={type}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          required={required}
          className="form-input"
          placeholder=""
        />
      )}
      <label ref={labelRef} htmlFor={id} className="floating-label-contact">
        {label || placeholder}
      </label>
    </div>
  );
}
